import React from 'react';
import { Input } from 'antd';
import type { AttackWithId, CustomFormFieldComponentProps } from '../../types/types';
import EditableListManager from '../../components/sheet/EditableListManager';

const AttackFields: React.FC<CustomFormFieldComponentProps> = ({ internalState, setInternalState }) => {
  return (
    <EditableListManager<AttackWithId>
      items={internalState?.attacks ?? []}
      onChange={(attacksUpdater) => {
        setInternalState(prevState => ({
          ...prevState,
          attacks: typeof attacksUpdater === 'function'
            ? attacksUpdater(prevState?.attacks ?? [])
            : attacksUpdater,
        }));
      }}
      defaultNewItem={() => ({ type: '', damage: '' })}
      addText="Add Attack"
      renderItemFields={(item, index, handleItemChange) => (
        <>
          <Input
            placeholder="Attack Type (e.g., Bite)"
            value={item.type}
            onChange={(e) => handleItemChange(index, { type: e.target.value })}
          />
          <Input
            placeholder="Damage (e.g., 1d8+2)"
            value={item.damage}
            onChange={(e) => handleItemChange(index, { damage: e.target.value })}
          />
        </>
      )}
    />
  );
};

export default AttackFields;